// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"rZ","promotionalTile":"r0","promotionalTileThumb":"r1","promotionalTileHeader":"r2","promotionalTileCaption":"r3"};